module.exports = __webpack_public_path__ + "img/ticket.5373cd61.svg";